import { DateService } from './../../services/date.service';
import { AdminService } from 'src/app/services/admin.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { ApiService } from 'src/app/services/api.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DataService } from 'src/app/services/data.service';

@Component({
  standalone: false,
  selector: 'app-member-details',
  templateUrl: './member-details.component.html',
  styleUrls: ['./member-details.component.scss']
})
export class MemberDetailsComponent implements OnInit {
  @ViewChild("contentActivation", { static: false }) content: ElementRef;
  @ViewChild("contentPriviledge", { static: false }) contentPriviledge: ElementRef;
  meetingNav: { index: string; name: string; link: string; }[];
  activation: boolean;
  priviledge: boolean;
  selectAll: boolean = false;
  entryGate: any;
  meetingRoomAccess: any;
  deskAccess: any;
  privateSuiteAccess: any;
  closeResult: string;
  url: string;
  token: any;
  employeeDetails: any;
  accessPointList: any;
  useraccessPointChanged: any;
  accessPointChanged = [];
  accessPointListName: any;
  deptInfo: any;
  savedaccessPointList: any;
  details: any;
  acronym: any;
  statusText: string;
  tenantId;
  allSelected = false;
  constructor(private modalService: NgbModal, private apiService: ApiService, private dateSrv: DateService, private dataService: DataService, private appStateSrv: AppStateProvider, private adminSrv: AdminService) { }
  open(content) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: 'custom-class' }
    ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.entryGate = [
      { label: 'Turnstile 01', selected: true, Id: 0, selectedIndex: 0 },
      { label: 'Turnstile 02', selected: true, Id: 1, selectedIndex: 1 },
    ];
    this.meetingRoomAccess = [
      { label: 'Adventurer', selected: true, Id: 0, selectedIndex: 0 },
      { label: 'Passion', selected: true, Id: 1, selectedIndex: 1 },
      { label: 'Utopia', selected: true, Id: 1, selectedIndex: 2 },
      { label: 'Momentum', selected: true, Id: 1, selectedIndex: 3 },
      { label: 'Rocket', selected: true, Id: 1, selectedIndex: 4 },
      { label: 'Carnival', selected: true, Id: 1, selectedIndex: 5 }

    ];
    this.deskAccess = [
      { label: 'Flexi Desk 1', selected: true, Id: 0, selectedIndex: 0 },
      { label: 'Flexi Desk 2', selected: true, Id: 1, selectedIndex: 1 },
      { label: 'Flexi Desk 3', selected: true, Id: 1, selectedIndex: 2 },
    ];
    this.privateSuiteAccess = [
      { label: 'PS 01', selected: true, Id: 0, selectedIndex: 0 },
      { label: 'PS 02', selected: true, Id: 1, selectedIndex: 1 },
      { label: 'PS 03', selected: true, Id: 1, selectedIndex: 2 },
    ];
    this.meetingNav = [
      {
        index: "2",
        name: "Members",
        link: 'members/members-list/member-details'
      }
    ]
    const route = {
      index: "2",
      name: "Members",
      link: 'members/members-list/member-details'
    };

    this.appStateSrv.setSideNavState(route);

    this.details = JSON.parse(localStorage.getItem(
      AppConstant.localStorage.memberDetail
    ));
    console.log("this.details", this.details)
    this.getApiauthorizationToken();
  }

  getEmployeeDetails() {
    this.url = APIs.getUserInfo;
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.selectedMember)
    }
    const header = {
      Authorization: this.token
    }

    this.apiService.get(this.url, param, header).subscribe(
      (response: any) => {
        this.employeeDetails = response.data;
        if (this.employeeDetails) {
          if (this.employeeDetails.t0200OrgEmployees.length > 0) {
            this.tenantId = this.employeeDetails.t0200OrgEmployees[0].tenantId;
          }
          this.activation = this.employeeDetails.t0200OrgEmployees[0].isActive;
        }
        this.getName()
        this.getDepartmentDetails();
        this.getAccessPointList();
      },
      err => console.log('error', err)
    );
  }
  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    this.token = 'Bearer' + ' ' + localStorage.getItem(AppConstant.localStorage.token);
    if (this.token != null) {
      if (this.dataService.employeeDetails.value != null) {
        this.dataService.employeeDetails.subscribe((response) => {
          this.employeeDetails = response.data.m0200Users[0];
          this.deptInfo = response;
          this.getName();
        })
      }
      else {
        this.getEmployeeDetails();
      }

    }
    //});
  };
  getDepartmentDetails() {
    this.url = APIs.getUserDepartmentInfo;
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.selectedMember)
    }
    const header = {
      Authorization: this.token
    }
    this.apiService.get(this.url, param, header).subscribe(
      (response: any) => {
        this.deptInfo = response;
        // this.dataService.employeeDetails.next(this.deptInfo)
      },
      err => console.log('error', err)
    );
  }
  getUserAccessPointList() {
    this.url = APIs.getUserAccessPoints;
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.selectedMember)
    }
    const header = {
      Authorization: this.token
    }
    this.apiService.get(this.url, param, header).subscribe(
      (response: any) => {
        this.accessPointList = response;
        this.getSavedAccessPointList();

        console.log('accessPointList', this.accessPointList)
      },
      err => console.log('error', err)
    );
  }
  getAccessPointList() {
    if (this.tenantId) {
      this.url = APIs.getSavedAccessPoint
      const param = {
        TenantId: this.tenantId,
      };
      this.apiService.get(this.url, param).subscribe(
        (response: any) => {
          this.accessPointListName = response;
          this.getUserAccessPointList();
          console.log('accessPointListName', this.accessPointListName);
        },
        (err) => console.log('error', err)
      );
    }
    else {
      this.url = APIs.getAccessPoint;
      const header = {
        Authorization: this.token
      }
      this.apiService.get(this.url, '', header).subscribe(
        (response: any) => {
          this.accessPointListName = response;
          this.getUserAccessPointList();
          console.log('accessPointListName', this.accessPointListName)
        },
        err => console.log('error', err)
      );
    }
  }

  setAccessPoint() {
    if (this.accessPointList.list.length === this.accessPointListName.list.length) {
      this.allSelected = true
    }
    else {
      this.allSelected = false
    }
    if (this.tenantId) {
      console.log('this.accessPointList[0]', this.accessPointList);
      let modifiedAccessPoints: any = { ...this.accessPointListName };
      if (this.accessPointList.list.length > 0) {
        modifiedAccessPoints.list = modifiedAccessPoints.list.map(
          (accesspoints) => {
            this.accessPointList.list.forEach((acc) => {
              // if (acc.accessPointId == accesspoints.accessPointId)
              accesspoints['selected'] = false;
            });

            this.accessPointList.list.forEach((acc) => {
              if (acc.accessPointId == accesspoints.accessPointId)
                accesspoints['selected'] = true;
            });
            return accesspoints;
          }
        );
        console.log('modifiedAccessPoints', modifiedAccessPoints);

        this.entryGate = modifiedAccessPoints.list
          .filter((access) => access.accessPoint.type === 'entry_gate')
          .map((access) => {
            access['label'] = access.accessPoint.accessPointName;
            return access;
          });
        console.log(this.entryGate, "asdsadsasadsada");
        this.meetingRoomAccess = modifiedAccessPoints.list
          .filter((access) => access.accessPoint.type === 'meeting_room')
          .map((access) => {
            access['label'] = access.accessPoint.accessPointName;
            return access;
          });
        this.privateSuiteAccess = modifiedAccessPoints.list
          .filter((access) => access.accessPoint.type === 'team_room')
          .map((access) => {
            access['label'] = access.accessPoint.accessPointName;
            return access;
          });
        this.deskAccess = modifiedAccessPoints.list
          .filter((access) => access.accessPoint.type === 'desk')
          .map((access) => {
            access['label'] = access.accessPoint.accessPointName;
            return access;
          });
      } else {
        this.entryGate = modifiedAccessPoints.list
          .filter((access) => access.accessPoint.type === 'entry_gate')
          .map((access) => {
            access['label'] = access.accessPoint.accessPointName;
            access['selected'] = false;
            return access;
          });
        this.meetingRoomAccess = modifiedAccessPoints.list
          .filter((access) => access.accessPoint.type === 'meeting_room')
          .map((access) => {
            access['label'] = access.accessPoint.accessPointName;
            access['selected'] = false;
            return access;
          });
        this.privateSuiteAccess = modifiedAccessPoints.list
          .filter((access) => access.accessPoint.type === 'team_room')
          .map((access) => {
            access['label'] = access.accessPoint.accessPointName;
            access['selected'] = false;
            return access;
          });
        this.deskAccess = modifiedAccessPoints.list
          .filter((access) => access.accessPoint.type === 'desk')
          .map((access) => {
            access['label'] = access.accessPoint.accessPointName;
            access['selected'] = false;
            return access;
          });



      }
    }
    else {
      console.log('this.accessPointList[0]', this.accessPointList);
      let modifiedAccessPoints: any = { ...this.accessPointListName };
      if (this.accessPointList.list.length > 0) {
        modifiedAccessPoints.list = modifiedAccessPoints.list.map(accesspoints => {
          this.accessPointList.list.forEach(acc => {
            if (acc.accessPointId == accesspoints.id)
              accesspoints['selected'] = true;
          });
          return accesspoints;
        });
        console.log('modifiedAccessPoints', modifiedAccessPoints);

        this.entryGate = modifiedAccessPoints.list.filter(access => access.type === 'entry_gate').map(access => {
          access['label'] = access.accessPointName;
          return access;
        });
        this.meetingRoomAccess = modifiedAccessPoints.list.filter(access => access.type === 'meeting_room').map(access => {
          access['label'] = access.accessPointName;
          return access;
        });;
        this.privateSuiteAccess = modifiedAccessPoints.list.filter(access => access.type === 'team_room').map(access => {
          access['label'] = access.accessPointName;
          return access;
        });;
        this.deskAccess = modifiedAccessPoints.list.filter(access => access.type === 'desk').map(access => {
          access['label'] = access.accessPointName;
          return access;
        });;
      } else {
        this.entryGate = modifiedAccessPoints.list.filter(access => access.type === 'entry_gate').map(access => {
          access['label'] = access.accessPointName;
          access['selected'] = false;
          return access;
        });
        this.meetingRoomAccess = modifiedAccessPoints.list.filter(access => access.type === 'meeting_room').map(access => {
          access['label'] = access.accessPointName;
          access['selected'] = false;
          return access;
        });;
        this.privateSuiteAccess = modifiedAccessPoints.list.filter(access => access.type === 'team_room').map(access => {
          access['label'] = access.accessPointName;
          access['selected'] = false;
          return access;
        });;
        this.deskAccess = modifiedAccessPoints.list.filter(access => access.type === 'desk').map(access => {
          access['label'] = access.accessPointName;
          access['selected'] = false;
          return access;
        });;
      }
    }

    console.log('entryGate', this.entryGate);
    this.checkAllAccessStatus();
  }


  checkAllAccessStatus() {
    console.log('useraccessPointChanged', this.useraccessPointChanged);

    if (this.entryGate.some(access => access.selected == false) || this.meetingRoomAccess.some(access => access.selected == false) ||
      this.privateSuiteAccess.some(access => access.selected == false) || this.deskAccess.some(access => access.selected == false))
      this.allSelected = false;
    else
      this.allSelected = true;
  }


  getName() {
    var str = this.employeeDetails.userName.toUpperCase()
    var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    if (matches.length > 1) {
      var l = matches.slice(0, 2);
      this.acronym = l.join('');
    } else {
      this.acronym = matches.join(''); // JSON
    }
    return this.acronym


  }
  // acronym1(arg0: string, acronym: any) {
  //   throw new Error('Method not implemented.');
  // }
  updateUserAccessPoint() {
    const header = {
      Authorization: this.token
    }
    const data = {
      AccessPointList: this.useraccessPointChanged,
      userId: localStorage.getItem(AppConstant.localStorage.selectedMember),
      AccessOperationType: this.useraccessPointChanged[0].hasAccess,
      sendEmail: true,
    };
    this.apiService.post(APIs.updateUserAccessPoint, data, '', header).subscribe(
      result => {
        this.getUserAccessPointList();
      }
    )


    // return this.apiService.post(APIs.addemployee, data).pipe(map(response => {
    //   return response;
    // }));
  }
  getSavedAccessPointList() {
    this.url = APIs.getuserSavedAccessPoint;
    const header = {
      Authorization: this.token
    }
    const paramobj = {
      UserId: localStorage.getItem(AppConstant.localStorage.selectedMember)
    }
    this.apiService.get(this.url, paramobj, header).subscribe(
      (response: any) => {
        this.savedaccessPointList = response;
        this.accessPointListName.list.forEach((item) => {
          this.savedaccessPointList.list.forEach((data, index) => {
            if (data.accessPointId == item.id) {
              item.selected = false;
              this.showAccess(item, index)
            }

          })

        });
        this.setAccessPoint();
        console.log('accessPointList', this.accessPointList)
      },
      err => console.log('error', err)
    );
  }
  showAccess(eg, i) {
    this.useraccessPointChanged = [];
    let data = eg;
    let index = this.savedaccessPointList.list.indexOf(data);
    data.selected = !data.selected;
    this.savedaccessPointList[index] = data;
    if (data.selected == true) {
      // let userAccessPointChanged:{ type: string; AccessPointId: any; CreatedBy: any; };
      // userAccessPointChanged.type=data.type;
      // userAccessPointChanged.AccessPointId=data.id;
      // userAccessPointChanged.CreatedBy=data.createdBy;
      this.accessPointChanged.push({
        type: data.type,
        AccessPointId: data.id,
        CreatedBy: data.createdBy
      });
    }

  }
  changeAccess(eg, i) {
    if (!this.activation) {
      return;
    }
    this.useraccessPointChanged = [];
    let data = eg;
    let index = this.accessPointList.list.indexOf(data);
    let selected = !data.selected;
    data = this.tenantId ? eg.accessPoint : eg;
    this.accessPointList[index] = data;
    if (selected == true) {
      // let userAccessPointChanged:{ type: string; AccessPointId: any; CreatedBy: any; };
      // userAccessPointChanged.type=data.type;
      // userAccessPointChanged.AccessPointId=data.id;
      // userAccessPointChanged.CreatedBy=data.createdBy;
      this.accessPointChanged.push({
        type: data.type,
        AccessPointId: data.id,
        CreatedBy: data.createdBy
      });
      this.useraccessPointChanged.push({
        type: data.type,
        AccessPointId: data.id,
        CreatedBy: data.createdBy,
        hasAccess: true
      });

    }
    if (selected == false) {
      this.accessPointChanged.splice(i, 1)
      this.useraccessPointChanged.push({
        type: data.type,
        AccessPointId: data.id,
        CreatedBy: data.createdBy,
        hasAccess: false
      });
      // this.accessPointChanged.push(data);
    }
    this.checkAllAccessStatus();
    this.updateUserAccessPoint();
    console.log("ebtry", this.accessPointChanged)

  }
  toggleActivationSelection(show) {
    this.activation = !this.activation;
    this.statusText = (this.activation ? "Activate" : "Deactivate");
    if (!this.activation) {
      this.open(this.content);
    }
    // if(this.activation){
    //   this.entryGate.forEach(item => item.selected = true);
    //   this.meetingRoomAccess.forEach(item => item.selected = true);
    //   this.deskAccess.forEach(item => item.selected = true);
    //   this.privateSuiteAccess.forEach(item => item.selected = true);
    //  }
    //  else{
    //   this.entryGate.forEach(item => item.selected = false);
    //   this.meetingRoomAccess.forEach(item => item.selected = false);
    //   this.deskAccess.forEach(item => item.selected = false);
    //   this.privateSuiteAccess.forEach(item => item.selected = false);
    //  }
  }
  // revokeAccess() {
  //   // this.open(this.content);
  // }

  revokeAccess(type: string) {
    // this.open(this.content);
    console.log('employeeDetails', this.employeeDetails, 'type', type);

    switch (type) {
      case 'activation':
        this.adminSrv.changeActivation(!this.employeeDetails.isActive, this.employeeDetails.userId).subscribe(response => {
          console.log('response in component', response);
          // window.location.reload();
          this.modalService.dismissAll();
        })
        break;
      case 'privilege':
        break;
    }
  }
  onCancel(module) {
    if (module == 'activation') {
      this.activation = !this.activation;
    }
    else {
      this.togglePriviledgeSelection(this.priviledge);
    }
    // this.activation=!this.activation;
  }

  togglePriviledgeSelection(show) {
    this.priviledge = !this.priviledge;
    if (!this.priviledge) {
      this.open(this.contentPriviledge);

    }
  }

  toggleSelectAllSelection(show) {
    this.useraccessPointChanged = [];
    this.selectAll = !this.allSelected;
    if (this.selectAll) {
      this.accessPointListName.list.forEach((data, index) => {
        if (this.tenantId) {
          this.useraccessPointChanged.push({
            type: data.accessPoint.type,
            AccessPointId: data.accessPoint.id,
            CreatedBy: data.accessPoint.createdBy,
            hasAccess: false
          });
        }
        else {
          this.useraccessPointChanged.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false
          });
        }
      });

    }
    else {
      this.accessPointListName.list.forEach((data, index) => {
        // data.selected=true;
        // this.changeAccess(data,index)
        if (this.tenantId) {
          this.useraccessPointChanged.push({
            type: data.accessPoint.type,
            AccessPointId: data.accessPoint.id,
            CreatedBy: data.accessPoint.createdBy,
            hasAccess: true
          });
        }
        else {
          this.useraccessPointChanged.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true
          });
        }
      });
    }
    this.updateUserAccessPoint();
  }

  updateTenantMember() {
    const data = {
      UserId: localStorage.getItem(AppConstant.localStorage.selectedMember),
      IsActive: this.activation,
    };
    const header = {
      Authorization: this.token
    };
    this.apiService.post(APIs.updateTenantMemberStatus, data, '', header).subscribe(
      (result) => {
        this.getEmployeeDetails();

      },
      (error) => { }
    );
  }

  updateTenantMemberStatus() {
    this.updateTenantMember();
  }
  convertDateFormat(date) {
    if (date !== null)
      return this.dateSrv.convertDateToLocaleString(
        date.split('-')[0],
        date.split('-')[1] - 1,
        date.split('-')[2]
      );
  }
}
